<template>
    <ListPage
        :query="query"
        :total="total"
        v-loading="loading"
        :data="tableData"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        @search="handleSearch"
        @reset="resetQuery"
    >
        <template slot="filters">
            <el-form-item label="" prop="search_keyword">
                <el-input v-model="query.search_keyword" placeholder="输入操作账号进行检索" clearable @keyup.enter.native="handleSearch" />
            </el-form-item>
            <el-form-item label="操作时间" prop="date">
                <el-date-picker
                    v-model="query.date"
                    type="daterange"
                    align="left"
                    unlink-panels
                    range-separator="-"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>
        </template>
        <template slot="columns">
            <el-table-column label="操作账号" align="center" prop="admin_name" />
            <el-table-column label="操作类型" align="center" prop="menu_name" />
            <el-table-column label="说明" align="center" prop="operation" />
            <el-table-column label="操作时间" align="center" prop="create_time" />
            <el-table-column label="登录IP" align="center" prop="admin_ip" />
        </template>
    </ListPage>
</template>

<script>
import { list } from "@/api/auth/log";
import { startDate, endDate } from "@/pages/config";
import listMixin from "@/mixins/list";

export default {
    data() {
        return {
            list,
            // 查询参数
            query: {
                search_keyword: "",
                date: [],
            },
        };
    },
    mixins: [listMixin],
    mounted() {
        this.search();
    },
    methods: {
        search() {
            const params = {
                ...this.query,
                search_start_time: this.query.date && this.query.date[0] ? startDate(0, this.query.date[0]) : null,
                search_end_time: this.query.date && this.query.date[1] ? endDate(0, this.query.date[1]) : null,
            };
            this._search(params);
        },
    },
};
</script>
